<!--
 * @FileDescription: 新增信用用户对话框
 * @Author: 陈文景
 * @Date: 2022-12-27 13:48:03
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-dialog title="新增信用用户" :visible.sync="visible" width="1024px" :before-close="close">
    <el-table v-loading="loading" :data="credits" border row-key="key" :style="{ width: `${tableWidth}%` }">
      <el-table-column label="邮箱/手机号" width="300">
        <template v-slot="{ row }">
          <el-select v-model="row.userId" size="medium" filterable remote reserve-keyword placeholder="选择邮箱/手机号"  style="width:280px;" :remote-method="remoteMethod" :loading="userLoading">
            <!-- <el-option v-for="item in userOptions" :key="item.userId" :label="item.email" :value="item.userId" /> -->
            <el-option v-for="item in userOptions" :key="item.userId" :label="item.showName" :value="item.userId" :title="item.showName" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="设置额度(USD)">
        <template v-slot="{ row }">
          <el-input-number v-model="row.creditLimit" size="medium" controls-position="right" :precision="2" :min="100" :max="100000" placeholder="输入额度" />
        </template>
      </el-table-column>
      <el-table-column>
        <template slot="header">
          <span>生成类型</span>
          <el-tooltip effect="dark" placement="top">
            <div slot="content">
              按付款时间生成：订单付款后自动生成未出账账单
              <br />
              按发货时间生成：包裹状态变为已发货后自动生成未出账账单
            </div>
            <i class="icon-question el-icon-question" />
          </el-tooltip>
        </template>
        <template v-slot="{ row }">
          <el-select v-model="row.billType" size="medium" placeholder="请选择">
            <el-option label="按付款时间" :value="1" />
            <el-option label="按发货时间" :value="2" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="账期周期(天)">
        <template v-slot="{ row }">
          <el-select v-model="row.billCycle" size="medium" placeholder="请选择">
            <el-option v-for="item in billDayOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column align="center" width="80">
        <template v-slot="{ row }">
          <span v-if="credits[credits.length - 1].key === row.key" class="icon-circle-plus" @click="add">
            <i class="el-icon-circle-plus"></i>
          </span>
          <span v-else class="icon-remove" @click="() => remove(row.key)">
            <i class="el-icon-remove"></i>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button size="medium" @click="close">取 消</el-button>
      <el-button type="primary" size="medium" @click="save">确 认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import API from '@/api'
import uniqueId from 'lodash/uniqueId'
import cloneDeep from 'lodash/cloneDeep'

export default {
  data() {
    return {
      visible: false,

      tableWidth: 100,

      userLoading: false,
      userOptions: [],

      billDayOptions: [
        { label: '15天', value: 15 },
        { label: '30天', value: 30 },
        { label: '45天', value: 45 },
        { label: '60天', value: 60 },
        { label: '90天', value: 90 },
        { label: '120天', value: 120 }
      ],

      // 查询用户列表的请求参数
      userParameter: {
        email: undefined, // 查询关键字
        pageNumber: 1,
        pageSize: 20,
        users: []
      },

      loading: false,
      credits: [{ key: uniqueId(), userId: undefined, creditLimit: undefined, billType: undefined, billCycle: undefined }]
    }
  },
  methods: {
    /**
     * API 批量新增信用用户
     */
    async batchAddCreditUser(parameter) {
      let { code, message } = await API.batchAddCreditUser(parameter)
      if (code === 10000) {
        this.$emit('update')
        this.$message.success(message)
        this.close()
      } else {
        this.$message.error(message)
      }
    },

    /**
     * API 获取用户列表
     */
    async getUserOptions() {
      try {
        this.userLoading = true
        let { data } = await API.getUserOptions(this.userParameter)
        this.userOptions = data.list
      } catch (error) {
        throw new Error(error.message)
      } finally {
        this.userLoading = false
      }
    },

    /**
     * 用户邮箱远程搜索
     *
     * @param {String} query 搜索关键字
     */
    remoteMethod(query) {
      if (query) {
        this.userParameter.email = query
      } else {
        this.userParameter.email = undefined
      }
      this.getUserOptions()
    },

    /**
     * 新增
     */
    add() {
      this.credits.push({ key: uniqueId(), userId: undefined, creditLimit: undefined, billType: undefined, billCycle: undefined })
    },

    /**
     * 删除
     *
     * @param {Number} key 当前删除行的key
     */
    remove(key) {
      this.credits = this.credits.filter((item) => item.key !== key)
    },

    /**
     * 显示对话框
     */
    show() {
      this.visible = true
      this.getUserOptions()
    },

    /**
     * 保存
     */
    save() {
      let flag = true
      this.credits.forEach((item) => {
        if (!item.userId || !item.creditLimit || !item.billType || !item.billCycle) {
          flag = false
        }
      })
      if (flag) {
        let ids = this.credits.map((item) => item.userId)
        if (ids.length === new Set(ids).size) {
          let parameter = cloneDeep(this.credits).map((item) => {
            delete item.key
            return item
          })
          this.batchAddCreditUser(parameter)
        } else {
          this.$message.warning('用户邮箱重复！')
        }
      } else {
        this.$message.warning('请完整填写表单！')
      }
    },

    /**
     * 关闭对话框
     */
    close() {
      this.clear()
      this.visible = false
    },

    /**
     * 负责清除数据
     */
    clear() {
      this.credits = []
      this.credits.push({ key: uniqueId(), userId: undefined, creditLimit: undefined, billType: undefined, billCycle: undefined })
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-remove,
.icon-circle-plus {
  font-size: 20px;
  cursor: pointer;
}

.icon-remove {
  color: #f56c6c;
}

.icon-circle-plus {
  color: #99c41c;
}

.icon-question {
  margin-left: 5px;
  cursor: pointer;
}
</style>
